import { BookingCalendarInterface } from 'common/types/entities/BookingCalendarInterface'
import { BookingPaidCalendarInterface } from 'common/types/entities/booking-paid-calendar-interface'
import { FontProps } from 'common/utils/styleUtilsNew'
import React from 'react'
import { BookingCalendarSteps } from './constants'
import {
  CommonBookingCalendarStepItemUi,
  CommonBookingCalendarStepsUi,
} from './ui/common-calendar-steps-ui'

interface BookingCalendarStepsSwitcherProps {
  activeStep: BookingCalendarSteps
  entity: BookingCalendarInterface | BookingPaidCalendarInterface
  onPrevStepClick?: () => void
  onNextStepClick?: () => void
}

export const BookingCalendarStepsSwitcher = ({
  entity,
  activeStep,
  onPrevStepClick,
  onNextStepClick,
  ...stylesProps
}: BookingCalendarStepsSwitcherProps & FontProps) => {
  return (
    <CommonBookingCalendarStepsUi>
      <CommonBookingCalendarStepItemUi
        isActive={activeStep === BookingCalendarSteps.CalendarStep}
        activeColor={entity.selectedSlotBackgroundColor}
        textColor={
          activeStep === BookingCalendarSteps.CalendarStep
            ? entity.titlesColor
            : entity.color
        }
        style={{
          cursor:
            activeStep === BookingCalendarSteps.FormStep
              ? 'pointer'
              : 'default',
        }}
        onClick={() => {
          onPrevStepClick?.()
        }}
        {...stylesProps}
      >
        <span>{entity.calendarStepHeadline}</span>
        <p>{entity.calendarStepSubHeadline}</p>
      </CommonBookingCalendarStepItemUi>
      <CommonBookingCalendarStepItemUi
        isActive={activeStep === BookingCalendarSteps.FormStep}
        activeColor={entity.selectedSlotBackgroundColor}
        textColor={
          activeStep === BookingCalendarSteps.FormStep
            ? entity.titlesColor
            : entity.color
        }
        onClick={() => {
          onNextStepClick?.()
        }}
        style={{
          cursor:
            activeStep === BookingCalendarSteps.CalendarStep
              ? 'pointer'
              : 'default',
        }}
        side="right"
        {...stylesProps}
      >
        <span>{entity.formStepHeadline}</span>
        <p>{entity.formStepSubHeadline}</p>
      </CommonBookingCalendarStepItemUi>
    </CommonBookingCalendarStepsUi>
  )
}
